export default "__VITE_ASSET__45be1c25__"